import CoreFormComponent from './CoreFormComponent';

export { type CoreFormComponentProps } from './CoreFormComponent';
export default CoreFormComponent;
